import React, { useEffect, useState } from 'react';
import { Navigate,useParams } from 'react-router-dom';
import { useGlobalContext } from '../../../Context/GlobalContext';
import { CircularProgress } from '@mui/material';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ children}) => {
  const { userData,dataLoading } = useGlobalContext();
  const { tenant } = useParams<{ tenant: string }>();
  const [isVerified, setIsVerified] = useState(false); 

  useEffect(() => {
    const verifyUser = async () => {

      if (dataLoading) {
        // Wait for loading to be false before verifying
        return;
      }

      if (!userData) {
        return <Navigate to={`/${tenant}/Joblisting`} replace />;
      }

      const userRole = userData.UserRole?.toLowerCase();

      if (userRole === 'admin' || userRole === 'super admin') {
        setIsVerified(true);
        return;
      }

      setIsVerified(true);
    };

    verifyUser();
  }, [tenant,dataLoading]);

  return isVerified ? <>{children}</> : null;
};

export default RoleProtectedRoute;
